import AxiosInstance from '../config/AxiosInstance';

export interface SupplierReturnPayload {
    locationId: string;
    supplierId: string;
    orderId: string;
    statusId: number;
    reason: string;
    supplierReturnDetails: SupplierReturnDetail[];
}

export interface SupplierReturnDetail {
    productId: string;
    originalOrderDetailId: string;
    qtyReturned: number;
    unitCost: number;
    lineCost: number;
    taxRateId: string;
    productUOMId: string;
}

const createSupplierReturn = async (payload: SupplierReturnPayload) => {
    try {
        const { data } = await AxiosInstance.post('/api/inventory/supplier-returns', payload);
        return { data };
    } catch (error) {
        throw error;
    }
}

const updateSupplierReturn = async (payload: SupplierReturnPayload, id: string) => {
    try {
        const { data } = await AxiosInstance.put('/api/inventory/supplier-returns/' + id, payload);
        return { data };
    } catch (error) {
        throw error;
    }
}

const deleteSupplierReturn = async (id: string) => {
    try {
        const { data } = await AxiosInstance.delete('/api/inventory/supplier-returns/' + id);
        return { data };
    } catch (error) {
        throw error;
    }
}


export {
    createSupplierReturn,
    updateSupplierReturn,
    deleteSupplierReturn

}